import React from "react"
import { useApplyContext } from "./context"

const AppLoadingOverlay = () => {
  const { appLoadingStatus, appLoading } = useApplyContext()

  return appLoading ? (
    <div
      className="bg-white"
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        zIndex: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div className="loader"></div>
      <h3 className="mt-5">
        {appLoadingStatus ? appLoadingStatus : "Initializing App"}
      </h3>
    </div>
  ) : null
}

export default AppLoadingOverlay
